 export const plans = [
    {
      name: "Starter",
      price: 499,
      period: "/month",
      features: [
        "Up to 500 customers",
        "Unlimited integrations",
        "Unlimited users"
      ],
      buttonText: "Get demo",
      buttonStyle: "green",
      highlight: false
    },
    {
      name: "Growth",
      price: 999,
      period: "/month",
      features: [
        "Up to 2,000 customers",
        "Unlimited integrations",
        "Unlimited users"
      ],
      buttonText: "Get demo",
      buttonStyle: "white",
      highlight: false
    },
    {
      name: "Scale",
      price: 1999,
      period: "/month",
      features: [
        "Up to 5,000 customers",
        "Unlimited integrations",
        "Unlimited users"
      ],
      buttonText: "Get demo",
      buttonStyle: "white",
      highlight: false
    }
  ];

  export const enterprisePlan = {
    name: "Enterprise",
    description: "Need something that fits your needs a bit better? Let's chat!",
    features: [
      "Unlimited contacts",
      "Unlimited integrations",
      "Unlimited users"
    ],
    buttonText: "Contact Sales",
    buttonStyle: "white"
  };